export const FounderNote = () => {
  return (
    <section className='cc-founder-note'>
      <div className='container'>
        <div className='cc-founder-card'>
          <div className='cc-founder-layout'>
            <img src='img/dave-founder.png' alt='Dave Williams' className='cc-founder-photo' />
            <div>
              <p>
                After managing people in the restaurant industry for over 20 years, I’ve gained a deep understanding of what it takes to motivate a team.
                Consistent, positive reinforcement is the most effective way to bring out the best in your people. With that experience in mind, I developed Crew Coin.
              </p>
              <p className='cc-founder-signoff'>-Dave Williams, Founder</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
